import React, { Component } from 'react';

class DatePicker extends Component {

  componentDidMount() {
    this.$el = window.$(this.el);
    this.$el.datepicker({
      format: 'yyyy-mm-dd'
    });
  }

  get date(){
    return this.$el.val();
  }
  
  render() {
    return (
      <input className="date form-control"
             ref={el => this.el = el}
             value={this.props.date} type="text"/>
    );
  }
}

class TestRoute extends Component {

  render() {
    return <DatePicker/>;
  }
}

export default DatePicker;
export {TestRoute};





















// WEBPACK FOOTER //
// ./src/datePicker.js